import { useToast } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { AddressLookupInput, AddressLookupResult } from "../models";
import { axiosInstance } from "../../utils";

export function useAddressLookup() {
    const axios = axiosInstance();
    const toast = useToast();

    return useMutation({
        mutationFn: (input: AddressLookupInput) => axios.post<AddressLookupResult>("api/AddressLookup", input).then(response => response.data),
        onError: error => {
            const axiosError = error as AxiosError;
            toast({
                title: "Address lookup failed",
                description: `[${axiosError.response?.status ?? "ERR"}]: ${axiosError.message}`,
                status: "error",
                isClosable: true,
                duration: null,
            });
        },
    });
}
